import { cn, RadioGroup, RadioGroupItem, Text } from 'ui_2';

export type FilterButtonOption = {
  value: string;
  label: string;
};

type FilterGroupProps = {
  options: FilterButtonOption[];
  defaultValue?: string;
  onChange?: (value: string) => void;
  className?: string;
};

export const FilterButtons = ({
  options,
  defaultValue,
  onChange,
  className,
}: FilterGroupProps) => {
  return (
    <RadioGroup
      defaultValue={defaultValue}
      className={cn('inline-flex flex-wrap rounded-full', className)}
      onValueChange={onChange}
    >
      {options.map((option) => (
        <div key={option.value} className='flex items-center'>
          <RadioGroupItem
            value={option.value}
            id={option.value}
            className='peer hidden'
          />
          <label
            htmlFor={option.value}
            className='flex cursor-pointer items-center justify-center rounded-full border border-gray-200 px-4 py-1.5 transition-colors duration-300 hover:bg-gray-100 peer-data-[state=checked]:bg-gray-600 peer-data-[state=checked]:text-white'
          >
            <Text className='text-inherit'>{option.label}</Text>
          </label>
        </div>
      ))}
    </RadioGroup>
  );
};
